var $ = global.jQuery = global.$;
var widgets = require('../lib/widgets');
var utils = require('../lib/utils');

var Icon = require('./Icon');
var _Base = require('./_Base');

var ShowHide = _Base.extend({
  init: function() {
    var self = this;

    this.classes = {
      open: 'is-open'
    };

    this.$content = this.$el.find('[data-content]').eq(0);
    this.$toggle = this.$el.find('[data-toggle]').eq(0);
    this.$icon = this.$toggle.find('[data-icon]');
    this.isOpen = this.$el.hasClass(this.classes.open);
    this.uniquedId = 'sh' + utils.getUniqueId();

    this.addAttributes();

    if (this.$icon.length) this.iconToggle = new Icon(this.$icon,{startIcon:'arrow-down',toggleIcon:'arrow-up'});

    if (this.isOpen) {
      this.open(false, 0);
    } else {
      this.close(false, 0);
    }

    this.$toggle.on('click', function(event) {
      event.preventDefault();
      self.toggle();
    });
  },
  addAttributes: function() {
    this.ids = {
      toggle: this.uniquedId + '-toggle',
      content: this.uniquedId + '-content'
    };
    this.$toggle.attr('id',this.ids.toggle);
    this.$toggle.attr('role','tab');
    this.$toggle.attr('tabindex','0');
    this.$toggle.attr('aria-controls',this.ids.content);
    this.$content.attr('id',this.ids.content);
    this.$content.attr('role','tabpanel');
    this.$content.attr('aria-labelledby',this.ids.toggle);
  },
  onWidgetsReady: function() {
    if (this.isOpen && this.iconToggle) this.iconToggle.toggle();

    this.childWidgets = widgets.getDescendants(this.$content);
  },
  toggle: function() {
    var transition;
    if (this.isOpen) {
      this.close(transition);
    } else {
      this.open(transition);
    }
  },
  open: function(transition, duration) {
    var self = this;
    transition = transition || 'slideDown';
    duration = duration || duration === 0 ? duration : 300;
    if (this.iconToggle) this.iconToggle.change(this.iconToggle.toggleIcon);
    if (transition === 'slideDown') this.$content.css('opacity', 1);
    this.$content.find('[data-slides]').height('auto');
    this.$content.velocity(transition, {
      duration: duration,
      complete: function() {
        self.$el.addClass(self.classes.open);
        self.isOpen = true;
        self.$toggle.attr('aria-selected',true);
        self.$content.attr('aria-hidden',false);
        self.redrawChildren();
      }
    });
  },
  close: function(transition, duration) {
    var self = this;
    transition = transition || 'slideUp';
    duration = duration || duration === 0 ? duration : 300;
    if (this.iconToggle) this.iconToggle.change(this.iconToggle.startIcon);
    this.$content.velocity(transition, {
      duration: duration,
      complete: function() {
        self.$el.removeClass(self.classes.open);
        self.isOpen = false;
        self.$toggle.attr('aria-selected',false);
        self.$content.attr('aria-hidden',true);
      }
    });
  },
  redrawChildren: function() {
    $.each(this.childWidgets, function() {
      if (this.redraw && typeof this.redraw === 'function') this.redraw();
    });
  }
});

module.exports = ShowHide;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/ShowHide.js
// module id = 302
// module chunks = 0